import React, { useEffect, useState } from "react";
import gallery from "../gallery.json";
import { referenceCategories } from "../referenceCategories";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const keys = referenceCategories.map(category => category.key);
const keyToIndex = Object.fromEntries(keys.map((k, i) => [k, i]));

export default function Referenser(props) {

  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = React.useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  // Uppdatera tab när query ändras (inkl. första render)
  useEffect(() => {
    const key = searchParams.get("ref");
    if (key && key in keyToIndex) {
      setActiveTab(keyToIndex[key]);
    } else {
      setActiveTab(0);
    }
  }, [searchParams]);

  const handleTabChange = (index) => {
    setActiveTab(index);
    const params = new URLSearchParams(location.search);
    params.set("ref", keys[index]);
    // Pushar ny historikpost (inte replace) så back/forward funkar
    navigate({ search: params.toString() });
  };

  const viewImg = (e) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute("href");
    // open image in a modal centered on screen
    const modal = document.createElement("div");
    modal.style.position = "fixed";
    modal.style.top = "0";
    modal.style.left = "0";
    modal.style.width = "100%";
    modal.style.height = "100%";
    modal.style.backgroundColor = "rgba(0,0,0,0.8)";
    modal.style.display = "flex";
    modal.style.alignItems = "center";
    modal.style.justifyContent = "center";
    modal.style.zIndex = "1000";
    modal.onclick = () => {
      document.body.removeChild(modal);
    };

    const img = document.createElement("img");
    img.src = href;
    img.style.maxWidth = "90%";
    img.style.maxHeight = "90%";
    img.style.boxShadow = "0 0 10px #000";

    modal.appendChild(img);
    document.body.appendChild(modal);


    // Open image in new window
    //const imgWindow = window.open(href, '_blank', 'toolbar=0,location=0,menubar=0');
    //imgWindow.focus();
  }

  return (
    <article id="referenser" className="fullwidth orangered">
      <section>
        <h2 id="referenser_title">Referenser</h2>

        <Tabs inFocusIndex={activeTab} onChange={handleTabChange}>
          {referenceCategories.map(category => (
            <div title={category.title} key={category.key}>
              <div className="referenceThumbs">
                {(gallery[category.galleryKey || category.key] || []).map((img, index) => (
                  <div key={img} className="thumb">
                    <a href={`/images/referensbilder/${category.folder}/${img}`} onClick={viewImg} target="_blank" rel="noreferrer">
                      <img src={`/images/referensbilder/${category.folder}/JPEG/${img}`} alt={`${category.title} – projektbild ${index + 1}`} loading="lazy" />
                    </a>
                  </div>
                ))}
              </div>
              {!(gallery[category.galleryKey || category.key] || []).length && <p className="gallery-empty">Projektbilder kommer snart. Kontakta oss gärna för att diskutera ditt projekt.</p>}
            </div>
          ))}
        </Tabs>

      </section>
    </article>
  )
}

function Tabs(props) {

  const tabs = React.Children.toArray(props.children);
  const [inFocusIndex, setInFocusIndex] = useState(props.inFocusIndex || 0);

  useEffect(() => {
    setInFocusIndex(props.inFocusIndex || 0);
  }, [props.inFocusIndex])

  const changePage = (index) => {
    props.onChange?.(index);
    setInFocusIndex(index);
  }

  return (
    tabs.length === 1 ?
      props.children
      :
      <div className="tabs">

        <div className="tabs-header">
          {tabs.map((tab, index) => {
            return (
              <button type="button" onClick={() => { changePage(index) }} key={index} className={`tabTitle ${inFocusIndex === index ? 'active' : ''}`}>
                {tab.props.title || 'Tab'}
              </button>
            )
          })}
        </div>

        {tabs.map((tab, index) => {
          return (
            <Tab key={index} index={index} inFocusIndex={inFocusIndex}>
              {tab}
            </Tab>
          )
        })}


      </div>
  )
}

const Tab = (props) => {
  const { children, index } = props;
  const [isInFocus, setIsInFocus] = useState(index === props.inFocusIndex);

  useEffect(() => {
    setIsInFocus(index === props.inFocusIndex);
  }, [index, props.inFocusIndex])

  return (
    isInFocus ? <div className="tab-content"><div className="scroll">{children}</div></div> : null
  )
}